/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function BioDynamicIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
      }}
      viewBox="0 0 20 20"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M2.911 8.354a9.24 9.24 0 019.133 10.66A9.24 9.24 0 01.868 8.582a9.268 9.268 0 012.043-.228zm16.184 0c.042.359.146 1.276.146 1.646 0 3.914-2.564 7.26-6.001 8.607.035-.273-.07-2.458-.13-3.548.143-1.409 1.696-3.748 3.725-5.422-2.366.865-3.668 1.993-4.46 3.39a10.52 10.52 0 00-1.477-2.26c2.342-1.783 3.578-2.327 8.197-2.413zM2.911 10.38l-.116.001.005.093a7.216 7.216 0 007.08 6.74l.12.001.116-.001-.005-.093a7.216 7.216 0 00-7.08-6.74l-.12-.001zM10 .76c2.435 0 4.65.942 6.301 2.481l.627-.72 1.563 4.377-4.552-.938 1.033-1.189A7.217 7.217 0 003.392 7.1a10.579 10.579 0 00-2.21.13A9.245 9.245 0 0110 .76z"
      ></path>
    </svg>
  );
}
